export default [
  {
    key: "applicationScopes",
    rules: {
      isRequired: true,
    }
  },
]
